module.exports = __webpack_public_path__ + "static/media/Salerno80x80 Porclain1.376c651a.jpg";